import BlankGift from '@components/blank/BlankGift';
import Column from '@components/Column';
import Filter from '@components/Filter';
import NewGiftFab from '@components/gift/NewGiftFab';
import useAppCustom from '@hooks/useAppCustom';
import { GiftBoxType } from '@models/gift';
import { Fragment, useState } from 'react';

import GiftBoxChips from './components/GiftBoxChips';
import TransactionItem from './components/TransactionItem';
import useGiftBoxes from './hooks/useGiftBoxes';
import styles from './styles.module.scss';

function GiftBoxFragment() {
  const [type, setType] = useState<GiftBoxType>(GiftBoxType.RECEIVED);
  const [sort, setSort] = useState('CreatedAtDesc');
  const data = useGiftBoxes(type, sort);
  const { useExternalCouponInGift } = useAppCustom().coupon;
  return (
        <Fragment>
            <Column as='section' fullWidth>
                <GiftBoxChips type={type}
                              setType={setType} />
                <Filter title='보기 설정'
                        sort={sort}
                        setSort={setSort}
                        sortItems={[{ value: 'CreatedAtDesc', label: '등록순' },
                          { value: 'ExpiredAtAsc', label: '유효기간 임박순' }]}/>
                {data?.length === 0 && (
                    <BlankGift type={type === GiftBoxType.RECEIVED
                      ? 'RECEIVE' : 'SEND'} />
                )}
                <article className={styles.contents}>
                    {data?.map((giftBox) => (
                        <TransactionItem giftBox={giftBox}
                                         key={giftBox.itemId} />
                    ))}
                </article>
            </Column>
            {useExternalCouponInGift && (
                <NewGiftFab/>
            )}
        </Fragment>
  );
}

export default GiftBoxFragment;
